<template>
  <div id="schedule">
  
    <div class="family">
      <div class="header">Family Fun in the Park</div>
      <div class="family-event" v-for="(item, index) in family" :key="index">
        <div class="time">
          <div class="time-holder">{{ item.time }}</div>
        </div>
        <div class="text" :class="{bold: item.bold}">{{ item.text }}</div>
        <div class="clear"></div>
      </div>
    </div>
    <div class="sound-stage">
      <div class="header">Canada Day Sound Stage</div>
      <div class="band" v-for="(band, index) in soundStage" :key="index">
        <a :href="band.link" target="_blank">
          <div class="name">{{ band.name }}</div>
          <div class="time">{{ band.time }}</div>
        </a>
      </div>
    </div>
    <div class="clear"></div>

  </div>
</template>

<script>
  
  export default {
    data () {
      return {
        family: [
          {
            time: '2 PM - 5 PM',
            text: 'Canada Day KIDS ZONE: Colouring, Bubbles, Chalk, and Tattoos',
          },
          {
            time: '2 PM - 7 PM',
            text: 'Inflatable Rides & Games',
          },
          {
            time: '2 PM - 9 PM',
            text: 'Free Spray Pad and Saturn Playground',
          },
          {
            time: '2 PM - 10 PM',
            text: 'Variety of food vendors',
          },
          {
            time: '4:00 PM',
            text: 'Metro Cake Cutting Ceremony',
          },
          {
            time: '6:30 PM',
            text: 'Free Family Movie in the Gym',
          },
          {
            time: '10:00 PM',
            text: 'FIREWORKS',
            bold: true
          }
        ],
        soundStage: [
          {
            name: 'TLA Band',
            time: '3:00 PM',
            link: 'https://www.facebook.com/p/TLA-Three-Letter-Acronym-Band-100063707611740/'
          },  
          {
            name: 'Big Bang',
            time: '6:00 PM',
            link: 'https://bigbanglivemusic.com/'
          },
          {
            name: 'Tommy Solo',
            time: '8:00 PM',
            link: 'https://www.facebook.com/tsoloband/'
          },
        ],
      }
    }
  }
  
</script>

<style lang="scss">

  .clear {
    clear: both;
  }

  #schedule {
    background: rgba(0, 0, 0, .78);
  
    .header {
      background: rgba(200, 0, 0, .54);
      padding: 16px;
      text-align: center;
      color: #FFF;
      text-transform: uppercase;
      font-weight: 600;
    }

    .family {
      width: 60%;
      float: left;
  
      @media screen and (max-width: 800px) {
        float: none;
        width: 100%;
      }

      .family-event {
        
        margin: 24px 0;

        .time {
          font-size: 18px;
          color: #FFF;
          float: left;
          width: 30%;
          text-align: right;
          padding: 0 16px;
          box-sizing: border-box;
          color: rgba(255, 255, 255, .78);
        
          @media screen and (max-width: 800px) {
            font-size: 14px;
            font-weight: 600;
          }
        }

        .text {
          font-size: 18px;
          color: #FFF;
          float: left;
          width: calc(70% - 16px);

          &.bold {
            font-weight: 600;
          }
        }
      }
    }

    .sound-stage {
      width: 40%;
      float: right;
      padding: 0 0 40px;
    
      @media screen and (max-width: 800px) {
        float: none;
        width: 100%;
      }

      .band {
        margin: 24px 0 0;
        text-align: center;
        
        a {
          text-decoration: none;
        }

        .name {
          font-size: 24px;
          color: #FFF;
        }

        .time {
          font-size: 18px;
          margin: 8px 0 0;
          color: rgba(255, 255, 255, .78);
        }
      }

    }
  }

</style>